module.exports = __webpack_public_path__ + "9b21109d75ef4a362230e079dcdfa550.svg";